module.exports = __webpack_public_path__ + "static/img/smileTop.d97d7c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smileTop.png
// module id = lmNP
// module chunks = 2